import React from "react";
import ObjectDescription from "../components/ObjectDescription";

const Object = () => {
  return (
    <div className="container has-fade fade-in">
      <ObjectDescription />
    </div>
  );
};

export default Object;
